// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a.list-group-item[data-v-38c15142]:hover{color:var(--color1)}.modal .close.keepOpacity[data-v-38c15142]:hover{opacity:1}
`, "",{"version":3,"sources":["webpack://./layout/modal-cms-navigation.vue"],"names":[],"mappings":"AACA,yCACC,mBAAA,CAED,iDACC,SAAA","sourcesContent":["\na.list-group-item:hover {\n\tcolor: var(--color1);\n}\n.modal .close.keepOpacity:hover {\n\topacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
